import styled from 'styled-components';

const YTVideoListHolder = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	left: 0;
	top:0;
	overflow: hidden;

	@media only screen 
	and (min-device-width: 768px) 
	and (max-device-width: 1024px) 
	and (-webkit-min-device-pixel-ratio: 1) {
		max-height: 500px;
		overflow: auto;
	}

	@media only screen and (max-width: 920px) {
		width: calc(100% - 10px);
		margin-left: 5px;
		margin-right: 5px;
	}

	h2 , button {
		display: inline-block;
		margin-left: 25px;
	}

	h2 {
		color: #fdfdfc;
		font-family: 'Quicksand',sans-serif;
		-webkit-box-pack: justify;
		-webkit-justify-content: space-between;
		-ms-flex-pack: justify;
		justify-content: space-between;
		background: #5f7586 url(/static-assets/theme/svg/left-decoration.svg) center left -2px no-repeat;
		background-size: auto 110%;
		padding: 8px 20px 8px 40px;
		border-radius: 2em;
		border: 0;
		text-transform: uppercase;
		font-size: 24px;
		margin-bottom: 3px;
		width: calc(100% - 30px);
		margin-right: 15px;
		margin-left: 15px;
		@media only screen and (max-width: 548px) {
			font-size: 18px;
		}
		a {
		color: white;
		font-weight: 600;
		font-size: 17px;
		vertical-align: middle;
		position: relative;
		line-height: 1;
		top: 4px;
		svg {
			color: #d2d9df;
			position: relative;
			vertical-align: middle;
			top: -0.1em;
			right: 0;
			line-height: 1;
			margin-left: 10px;
			font-size: 18px;
			opacity: 0.8;
			transition: all 0.2s ease-in;
		}
		}
	}

	.close-btn {
		position: absolute;
		top: 28px;
		right: 4%;
		background-color: #5f7586;
		color: white;
		border: none;
		font-family: "Quicksand", sans-serif;
		font-weight: 600;
    	font-size: 17px;
		padding: 5px;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		cursor: pointer;
		z-index: 1;
		text-transform: uppercase;

		svg {
			color: #d2d9df;
			margin-left: 8px;
			font-size: 20px;
		}

		@media only screen and (max-width: 548px) {
			top: 18px;
			right: 7%;
		}
	}

	.seeAllBtn {
		color: #7a7652;
		cursor: pointer;
		text-decoration: none;
		background-color: none;
		border:none;
		&:hover {
			color: black;
		}
	}

	.carousel-container {
		position:relative;
		margin: 5px auto;
		overflow: hidden;
		max-width: calc(100% - 50px);
		ul {
			padding: 0 0 20px;
			@media only screen
			and (min-device-width: 768px) 
			and (max-device-width: 1024px) {
				padding: 0 0 30px;
			}
		}
		.carousel-item {
			padding-left: 12.5px;
			padding-right: 12.5px;

			img {
				width: 100%;
			}

			p {
				margin: 10px 0 0 10px;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;  
				overflow: hidden;
			}

			a {
				cursor: pointer;
				text-decoration: none;
				color: black;
				font-size: 18px;
				&:hover, &:focus {
					color: #7a7652;
				}
			}
		}
		.react-multiple-carousel__arrow {
			background: rgba(95, 117, 134, 0.7);
			&:hover {
				background: rgb(95, 117, 134);
			}
		}
		.react-multiple-carousel__arrow--right {
			right: 0;
			bottom: 0;
			@media only screen 
			and (min-device-width: 465px) 
			and (max-device-width: 1024px) {
				right: 1rem;
			}
			@media only screen 
			and (max-device-width: 464px) {
				bottom: unset;
				right: 10px;
			}
		}
		.react-multiple-carousel__arrow--left {
			left: 0;
			bottom: 0;
			margin-left: 0 !important;
			@media only screen 
			and (min-device-width: 465px) 
			and (max-device-width: 1024px) {
				left: 1rem;
			}
			@media only screen 
			and (max-device-width: 464px) {
				bottom: unset;
				left: 10px;
			}
		}
	}
	.dot-list-style {	 
		position:relative;
		height: 40px;
		width: 100%;
		margin-top: 23px;

		@media only screen 
		and (min-device-width: 768px) 
		and (max-device-width: 1024px) 
		and (-webkit-min-device-pixel-ratio: 1) {
			padding-left: 50px;
    		padding-right: 15px;
		}
	
		.react-multi-carousel-dot {
			button {
				height: 20px;
				width: 20px;
				margin-left: 8px;
				background-color: #97a7b5;
				border-color: #97a7b5;
				@media only screen and (max-width: 548px) {
					margin-left: 13px;
				}
			}
		}

		.react-multi-carousel-dot--active button {
			color: #5f7586;
			background-color: #5f7586;
			border-color: #5f7586;
		}
	}
`;

export default YTVideoListHolder;